import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useIsMobile } from "../../../../../components/Mui3WidthProvider";
import { BuilderAsset } from "../../../../../entities/BuilderAsset";
import { routes } from "../../../../../routes";
import { SaveBuilderAssetRequest, BuilderAssetService } from "../../../../../services/BuilderAssetService";
import { UserAgent } from "../../../../../utilities/UserAgent";
import { useLibraryAlert } from "../../../LibraryPage";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
	open: boolean;
	customTemplate: BuilderAsset;
	onClose: () => void;
}

export function AddFromCustomTemplateDialog(props: Props) {
	const { open, customTemplate } = props;
	const history = useHistory();
	const isMobile = useIsMobile();
	const libraryAlert = useLibraryAlert();
	
	const [disableActions, setDisableActions] = useState<boolean>(false);

	const onAddDocumentFromCustomTemplate = async () => {
		let request: SaveBuilderAssetRequest = {
			parentId: undefined,
			name: customTemplate.name,
			isStarred: false,
			dateAccessed: new Date(),
			category: customTemplate.category,
			text: customTemplate.text,
			slideCount: customTemplate.slideCount,
			isTemplate: false,
			templateDescription: "",
			slideExporterAspectRatio: customTemplate.slideExporterAspectRatio,
			customSlideBackgroundImagePath: customTemplate.customSlideBackgroundImagePath,
			offlineMode: false,
			lastModifiedFormFactor: UserAgent.getFormFactor(),
			lastModifiedOnOperatingSystem: UserAgent.getOperatingSystem(),
		};

		setDisableActions(true);
		let response = await BuilderAssetService.saveFromTemplate(request);
		setDisableActions(false);

		if(response.error) return libraryAlert(response.message)
		if(response.success) return history.push(routes.app.resolve.builderPage(response.data.id), { prevUrl: window.location.href });

	};

	return (
		<Dialog fullWidth maxWidth="md" open={open} onClose={props.onClose} fullScreen={isMobile}>
			<DialogTitle>
				<IconButton aria-label="Close" style={{ float: "right" }} onClick={props.onClose} disabled={disableActions}>
					<CloseIcon />
				</IconButton>
				<Typography variant="h5">{customTemplate.name}</Typography>
				<Typography variant="body2">{customTemplate.templateDescription}</Typography>
				<DialogActions>
					<Button
						color="primary"
						style={{
							marginTop: 5,
							marginBottom: 0,
							marginLeft: "auto",
							display: "flex",
							marginRight: "auto",
						}}
						size="large"
						onClick={onAddDocumentFromCustomTemplate}
						variant="contained"
						disabled={disableActions}
					>
						Use Template
					</Button>
				</DialogActions>
			</DialogTitle>
			<Divider />
			<DialogContent>
				<span style= {{
					WebkitUserSelect: "none",
					MozUserSelect: "none",
					msUserSelect: "none",
					userSelect: "none"
				}} dangerouslySetInnerHTML={{ __html: customTemplate.text }} />
			</DialogContent>
		</Dialog>
	);
}